import React, {useState} from 'react';
import useFeature from "../../useFeature";
import {LOGIN_PATH} from "../../routes";
import saporeLogo from "../../media/logos/logo-sapore.png";
import {RecoverPasswordFeature} from "./RecoverPasswordFeature";
import {observer} from "mobx-react";
import {useApplication} from "../../ApplicationProvider";


function RecoverPasswordScreen() {
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const application = useApplication()
    const feature = useFeature(() => new RecoverPasswordFeature(application))

    const recoverPassword = (event) => {
        event.preventDefault();
        feature.recoverPassword()
    };

    const isFeatureReady = () => {
        return feature !== null;
    }

    return (isFeatureReady() &&
        <div className="bg-login relative">
            <div className="center-center width100">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="panel panel-default">
                                <div className="panel-body">
                                    <img src={saporeLogo} className="img-logo-login" alt="Logo Sapore Di Pane"/>

                                    <h3 className="text-center clearmargin marginbottom30">Recuperar clave</h3>
                                    {error && (
                                        <div className="validation-summary-errors">
                                            <ul>
                                                <li>{error}</li>
                                            </ul>
                                        </div>
                                    )}
                                    {success ? (
                                        <div className="text-center">
                                            <p className="font20 margintop15 brandon">Se te ha enviado un email con los
                                                pasos para recuperar tu acceso.</p>
                                            <a href={LOGIN_PATH} className="btn btn-primary margintop30">Ir al
                                                inicio</a>
                                        </div>
                                    ) : (
                                        <form className="form-material" onSubmit={recoverPassword}>
                                            <div className="form-group label-floating is-fixed">
                                                <label htmlFor="email">Email</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    value={feature.emailField().value}
                                                    onChange={(event) => feature.updateEmail(event.target.value)}
                                                    placeholder="Ingrese su email"
                                                />
                                                {error && <div className="text-danger">{error}</div>}
                                            </div>
                                            <div className="form-login-actions text-center margintop50">
                                                <input type="submit" className="btn btn-primary form-control"
                                                       value="Aceptar"/>
                                            </div>
                                        </form>
                                    )}
                                    <div className="text-center margintop30">
                                        <a href={LOGIN_PATH} className="general-title">Ir al inicio</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default observer(RecoverPasswordScreen);
